var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag:common", arg: "common" }],
      attrs: {
        title: "导入测风塔",
        visible: _vm.visible,
        "show-close": false,
        width: "400px"
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.formData, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "原始数据",
                "label-width": "80px",
                prop: "fileIdOriginal"
              }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    action: _vm.action,
                    data: _vm.headers,
                    "on-success": _vm.onFileUploadSuccess,
                    accept: ".csv, .rld, .txt, .rwd"
                  }
                },
                [
                  _c(
                    "ct-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "质控数据",
                "label-width": "80px",
                prop: "fileIdValid"
              }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    action: _vm.action,
                    data: _vm.headers,
                    "on-success": (response, file, fileList) =>
                      _vm.onFileUploadSuccess(
                        response,
                        file,
                        fileList,
                        "fileIdValid"
                      ),
                    accept: ".csv, .rld, .txt, .rwd"
                  }
                },
                [
                  _c(
                    "ct-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "插补数据",
                "label-width": "80px",
                prop: "fileIdInterpolation"
              }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    action: _vm.action,
                    data: _vm.headers,
                    "on-success": (response, file, fileList) =>
                      _vm.onFileUploadSuccess(
                        response,
                        file,
                        fileList,
                        "fileIdInterpolation"
                      ),
                    accept: ".csv, .rld, .txt, .rwd"
                  }
                },
                [
                  _c(
                    "ct-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "ct-button",
            {
              staticStyle: { "margin-right": "10px" },
              attrs: { "btn-click": _vm.close, size: "small" }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "ct-button",
            {
              attrs: { type: "primary", "btn-click": _vm.submit, size: "small" }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }